import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import SARSIDType from "../../../Models/Catalogue/General/SARSIDType";

export default class SARSIDTypeCatalogueEntry extends CatalogueEntry<SARSIDType> {

    constructor() {
        super("SARS ID Types", SARSIDType);
    }

    public get editRole() {
        return CatalogueRoles.SARSIDTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.sarsIdTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveSARSIDTypes;
    }

    public renderRow(item: SARSIDType, meta: Model.TransformMetaType<SARSIDType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.sarsidTypeCode} />
                <NeoGrid.Column bind={meta.description} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}